import { useEffect } from 'react';
const GTM_ID = 'GTM-N2HGSSNS';
const SCRIPT_ID = 'gtm-script';
const NOSCRIPT_ID = 'gtm-noscript';
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Loads Google Tag Manager (container GTM-N2HGSSNS) plus the noscript
 * iframe fallback, without blocking the initial render.
 */
export function GoogleTagManager() {
  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js'
    });
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(script);
    if (!document.getElementById(NOSCRIPT_ID)) {
      const noscript = document.createElement('noscript');
      noscript.id = NOSCRIPT_ID;
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, []);
  return null;
}